var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaretCircle = function SvgCaretCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.504 7.676a1.5 1.5 0 0 1 2.1 0l7.353 7.349a1.477 1.477 0 0 1 .046 2.043l-7.246 7.242a1.482 1.482 0 1 1-2.1-2.089l6.159-6.228-6.312-6.232a1.46 1.46 0 0 1 0-2.085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16A16 16 0 1 0 16 0 16 16 0 0 0 0 16m2.462 0a13.533 13.533 0 0 1 23.107-9.569A13.533 13.533 0 1 1 6.431 25.569 13.42 13.42 0 0 1 2.462 16"
  })));
};
export default SvgCaretCircle;